<template>
 <div class="banner" v-if="isShow">
    <img class="bg" :src="bannerStyle.backgroundImage" />
    <div class="absolute-box">
      <img
        :src="bannerStyle.imgStyle1.src"
        :style="bannerStyle.imgStyle1.style"
      />
      <img
        :src="bannerStyle.imgStyle2.src"
        :style="bannerStyle.imgStyle2.style"
      />
    </div>
  </div>
</template>
<script setup>
import { computed, ref } from "vue";
import { useRoute } from 'vue-router'

const bannerStyle = ref(window.globalConfig.bannerStyle);
const hiddeList = ['/newsDetail'];
const route = useRoute();
const isShow = computed(()=> {
  return !hiddeList.includes(route.fullPath);
})
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  .bg {
    width: 100%;
  }
  .absolute-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    text-align: center;
  }
}

</style>